import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import MsgBox from 'components/MsgBox/MsgBox';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import CustomButton from 'components/CustomInput/Button/index';
import { SYSTEM_EDIT_BROADCAST_MESSAGE, GET_BROADCAST_MESSAGE } from 'store/key';
import CustomTextField from 'components/Input/CustomTextField';
import LoadingIndicator from 'components/LoadingIndicator';
import { getSystemMessage } from 'store/system/systemMessageReducer';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        overflow: 'hidden',
        height: '89vh',
    },
    title: {
        marginRight: theme.spacing(4),
        fontWeight: 'bold',
    },
}));

const EditBroadcastMessage = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const remoteBroadcastMessage = useSelector((state) => state.broadcastMessage.broadcastMessage);
    const remoteNews = useSelector((state) => state.broadcastMessage.news);
    const isLoading = useSelector((state) => state.broadcastMessage.isLoading);

    const [warningMsg, setWarningMsg] = useState(null);

    const [broadcastMessage, setBroadcastMessage] = useState('');
    const [news, setNews] = useState('');

    const [broadcastValid, setBroadcastValid] = useState(false);
    const [newsValid, setNewsValid] = useState(false);
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);

    useEffect(() => {
        if (remoteBroadcastMessage.text) {
            setBroadcastMessage(remoteBroadcastMessage.text);
        }
    }, [remoteBroadcastMessage]);

    useEffect(() => {
        if (remoteNews.text) {
            setNews(remoteNews.text);
        }
    }, [remoteNews]);

    const getList = () => {
        dispatch({
            type: GET_BROADCAST_MESSAGE,
            payload: {}
        });
    };

    useEffect(() => {
        getList();
        // eslint-disable-next-line
    }, []);

    const confirm = (data, msg, title) => {
        setWarningMsg({
            type: 'confirm',
            message: getSystemMessage('isSureToChange', [msg]),
            footerActions: [
                {
                    label: 'Cancel',
                    color: 'default',
                    clicked: () => {
                        setWarningMsg(null);
                    },
                },
                {
                    label: 'Confirm',
                    clicked: () => {
                        submit(data, title);
                        setWarningMsg(null);
                    },
                },
            ],
        });
    };

    const handleSaveBroadcastMsg = () => {
        setForceErrorDisplay(true);
        if (broadcastValid) {
            const data = {
                id: remoteBroadcastMessage.id,
                data: { text: broadcastMessage }
            };
            confirm(data, 'broadcast message', 'Broadcast Message');
        }
    };
    const handleSaveNews = () => {
        setForceErrorDisplay(true);
        if (newsValid) {
            const data = {
                id: remoteNews.id,
                data: { text: news }
            };
            confirm(data, 'news', 'News');
        }
    };

    const submit = (data, title) => {
        dispatch({
            type: SYSTEM_EDIT_BROADCAST_MESSAGE,
            payload: {
                ...data,
                callback: () => {
                    getList();
                    setWarningMsg({
                        message: getSystemMessage('hasBeenUpdated', [title]),
                        footerActions: [
                            {
                                label: 'Confirm',
                                clicked: () => {
                                    setWarningMsg(null);
                                },
                            },
                        ],
                    });
                },
            },
        });
    };

    const handleCancel = () => {
        history.push('/');
    };

    const handleReset = (type) => {
        if (!type) {
            setBroadcastMessage(remoteBroadcastMessage.text ?? '')
        } else {
            setNews(remoteNews.text ?? '')
        }
    };

    return (
        <Grid container wrap="nowrap" direction="column" className={classes.root}>
            {warningMsg ? (
                <MsgBox
                    type={warningMsg.type}
                    message={warningMsg.message}
                    footerActions={warningMsg.footerActions}
                    title={warningMsg.title}
                    closePopup={() => setWarningMsg(null)}
                />
            ) : null}
            <Grid container style={{ flex: 1 }} alignItems="baseline">
                {isLoading ? <Grid container alignItems="center" justify="center">
                    <LoadingIndicator />
                </Grid> : <Grid container>
                    <Grid container style={{ marginBottom: 20 }}>
                        <Grid container className={classes.title}>
                            Broadcast Message:
                        </Grid>
                        <Grid container style={{ padding: 16 }}>
                            <CustomTextField
                                isTextArea
                                fullWidth
                                label="Broadcast Message"
                                multiline
                                rows={12}
                                name="broadcastMsg"
                                value={broadcastMessage}
                                onChange={e => setBroadcastMessage(e.target.value)}
                                variant="outlined"
                                validators={['isRequired']}
                                isValidValue={valid => setBroadcastValid(valid)}
                                forceErrorDisplay={forceErrorDisplay}
                                maxLength={2550}
                                canPressEnter
                            />
                        </Grid>
                        <Grid container>
                            <CustomButton type={'cancel'} onClick={handleCancel}>Cancel</CustomButton>
                            <CustomButton
                                style={{ margin: '0 16px' }}
                                onClick={() => handleReset(0)}
                            >
                                Reset
                            </CustomButton>
                            <CustomButton onClick={handleSaveBroadcastMsg}>Confirm</CustomButton>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid container className={classes.title}>
                            News:
                        </Grid>
                        <Grid container style={{ padding: 16 }}>
                            <CustomTextField
                                isTextArea
                                fullWidth
                                label="News"
                                multiline
                                rows={12}
                                name="news"
                                value={news}
                                onChange={e => setNews(e.target.value)}
                                variant="outlined"
                                validators={['isRequired']}
                                isValidValue={valid => setNewsValid(valid)}
                                forceErrorDisplay={forceErrorDisplay}
                                maxLength={2550}
                                canPressEnter
                            />
                        </Grid>
                        <Grid container>
                            <CustomButton type={'cancel'} onClick={handleCancel}>Cancel</CustomButton>
                            <CustomButton
                                style={{ margin: '0 16px' }}
                                onClick={() => handleReset(1)}
                            >
                                Reset
                            </CustomButton>
                            <CustomButton onClick={handleSaveNews}>Confirm</CustomButton>
                        </Grid>
                    </Grid>
                </Grid>
                }
            </Grid>
        </Grid>
    );
};

export default EditBroadcastMessage;
